import { COMPLETION_CODE_MESSAGES, errorMessageOf } from '../errors/error-codes';
import { FE_MESSAGES } from './fe-messages';
import type { FeMessageId } from './fe-messages';
import { MESSAGES } from './messages';
import type { MessageId } from './messages';

export { FE_MESSAGES, MESSAGES };
export type { FeMessageId, MessageId };

export type AnyMessageId = MessageId | FeMessageId;

/** 既定の完了文言（MSG-S-049） */
export const DEFAULT_SUCCESS_MESSAGE_ID: MessageId = 'MSG-S-049';

export function isMessageId(id: string): id is AnyMessageId {
  return Object.prototype.hasOwnProperty.call(MESSAGES, id) || Object.prototype.hasOwnProperty.call(FE_MESSAGES, id);
}

function rawText(id: AnyMessageId): string {
  if (Object.prototype.hasOwnProperty.call(MESSAGES, id)) {
    return MESSAGES[id as MessageId].text;
  }
  return FE_MESSAGES[id as FeMessageId].text;
}

/**
 * メッセージ ID → 文言（03 4.1）。差し込み `${name}` は params で埋める。
 * 仕様書の差し込み名（例 `${company.company_name}`）は、params に完全な名前か最後の区切り（`company_name`）で渡す。
 */
export function t(id: AnyMessageId, params: Readonly<Record<string, string | number>> = {}): string {
  return rawText(id).replace(/\$\{([\w.]+)\}/g, (whole: string, name: string) => {
    const last_name = name.split('.').pop() ?? name;
    const value = params[name] ?? params[last_name];
    return value === undefined ? whole : String(value);
  });
}

/** エラーコード → 文言（03 4.2・02 2.6） */
export function errorText(code: string): string {
  return errorMessageOf(code);
}

/** 完了コード → 文言（02 2.6.2） */
export function completionText(code: keyof typeof COMPLETION_CODE_MESSAGES): string {
  return COMPLETION_CODE_MESSAGES[code];
}
